export const AXIOS_NETWORK_ERROR_EVENT = "midstates:axios-network-error";
export const AXIOS_NETWORK_ERROR_COOLDOWN_MS = 5000;

export const buildNetworkErrorNotification = () => ({
  title: "Network Error",
  message: "We couldn't connect to the server. Please check your internet connection and try again.",
  type: "error",
  duration: 10000,
});

export const getAxiosStatus = (error) => {
  if (error && error.response && error.response.status !== undefined && error.response.status !== null) {
    return error.response.status;
  }

  if (error && error.status !== undefined && error.status !== null) {
    return error.status;
  }

  if (error && error.request && error.request.status !== undefined && error.request.status !== null) {
    return error.request.status;
  }

  return null;
};

export const isCanceledAxiosError = (error) => {
  return Boolean(error && (error.code === "ERR_CANCELED" || error.name === "CanceledError"));
};

export const isNetworkAxiosError = (error) => {
  if (!error || isCanceledAxiosError(error)) {
    return false;
  }

  const requestStatus = error.request ? error.request.status : null;

  return (
    !error.response &&
    (error.code === "ERR_NETWORK" || error.message === "Network Error" || requestStatus === 0)
  );
};

export const shouldNotifyNetworkError = (
  lastNotificationAt,
  now = Date.now(),
  cooldownMs = AXIOS_NETWORK_ERROR_COOLDOWN_MS
) => {
  return now - lastNotificationAt >= cooldownMs;
};

export const shouldSuppressAxiosError = (error) => {
  const status = getAxiosStatus(error);

  return isNetworkAxiosError(error) || status === 401 || status === 403 || status === 499;
};

export default function useAxiosError() {
  return {
    AXIOS_NETWORK_ERROR_COOLDOWN_MS,
    AXIOS_NETWORK_ERROR_EVENT,
    buildNetworkErrorNotification,
    getAxiosStatus,
    isCanceledAxiosError,
    isNetworkAxiosError,
    shouldNotifyNetworkError,
    shouldSuppressAxiosError,
  };
}